import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListCreationScreen from '../enums/ListCreationScreen';
import ListItemType from '../enums/ListItemType';
import NavigatedFrom from '../enums/NavigatedFrom';

type logListAddedParams = {
  inspirational_list_type?: string;
  list_creation_screen: ListCreationScreen;
  list_id: number;
  list_type: ListItemType;
  navigated_from?: NavigatedFrom;
  page_slug?: string;
};

/**
 * The user has created a new list. This comes after selecting the list creation CTA and naming the list.
 * @param params - Attributes to log with the amplitude event
 * @param params.inspirational_list_type - inspirational list type of the page (programmatic list, sponsored list, trail, etc,), passed from server
 * @param params.list_creation_screen - The screen where list creation was completed— this is used to differntiate saved funnels.
 * @param params.list_id - The id of the newly created list.
 * @param params.list_type - The type of list created
 * @param params.navigated_from - The location the user navigated from to get to this content
 * @param params.page_slug - Page slug of inspirational list added by user
 */
const logListAdded = (
  { inspirational_list_type, list_creation_screen, list_id, list_type, navigated_from, page_slug }: logListAddedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'list added',
    {
      'inspirational list type': inspirational_list_type,
      'list creation screen': list_creation_screen,
      'list id': list_id,
      'list type': list_type,
      'navigated from': navigated_from,
      'page slug': page_slug
    },
    callback
  );
};

export default logListAdded;
